export class SettingService {

  private apiPort = 8011;


  get apiBasePath(): string {
     return `${window.location.protocol}//${window.location.hostname}:${this.apiPort}/api/`;
   // return 'http://infdev9:3020/api/';
  }
}
